// DS: UI09
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import CommentOutlineIcon from '../../Icons/CommentOutline';
import { IconSize } from '../../Icons/IconWrap';
import { gallectionTypeToResourceType } from '../../types/gallection';
import OverlayControl from '../../DeviationViews/Helper/OverlayControl';
import BiLink from '../../biLogger/Components/BiLink';
import { BiEventType } from '../../biLogger/constants';
import { VisuallyHidden } from '../../a11y';
import s from '../../DeviationViews/Thumb/Standard/Overlay/Overlay.scss';
function gallectionUrl(gallection) {
    // TODO: make using `#folder-comments-${gallection.folderId}` autoscroll to the comments - it won't atm
    return Url.userGalleryLink({
        username: gallection.owner.username,
        gallectionType: gallection.type === 'gallery' ? 'gallery' : 'collection',
        folderId: gallection.folderId,
        folderName: gallection.name,
    });
}
// TODO: refactor this and DeviationViews/Thumb/Standard/Overlay/OverlayControls/Comment
// into a base component and two wrapping components: GallectionCommentControl and DeviationCommentControl
var GallectionCommentControl = function (_a) {
    var gallection = _a.gallection, className = _a.className, iconClassName = _a.iconClassName;
    var t = useTranslation().t;
    return (React.createElement(OverlayControl, { className: className, stat: gallection.commentCount, extraStatContent: React.createElement(VisuallyHidden, null, t('deviationview.overlay.a11y.commentStat')) },
        React.createElement(BiLink, { "aria-label": t('deviationview.overlay.a11y.comment'), className: classnames(s['icon-button']), href: gallectionUrl(gallection), biData: {
                evid: BiEventType.THUMB_CLICK_COMMENT,
                typeid: gallectionTypeToResourceType(gallection.type),
                creatorid: gallection.owner ? gallection.owner.useridUuid : undefined,
                itemid: gallection.folderId,
            } },
            React.createElement(CommentOutlineIcon, { size: IconSize.COMPACT, withPadding: false, disableDefaultColors: true, className: classnames(s['icon'], iconClassName) }))));
};
GallectionCommentControl.displayName = 'GallectionCommentControl';
export default GallectionCommentControl;
//# sourceMappingURL=GallectionCommentControl.js.map